import { env, F18_SERVICES } from '../configs/Config'
import { apiCMSWithToken } from './axios'

export async function getAll(p = {}) {
  try {
    const params = new URLSearchParams({ ...p })
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.projectRecommend}?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function addProject(body) {
  try {
    const response = await apiCMSWithToken.post(
      F18_SERVICES.projectRecommend,
      body
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}
export async function updateProject(body, id) {
  try {
    const response = await apiCMSWithToken.put(
      `${F18_SERVICES.projectRecommend}/${id}`,
      body
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}
export async function detailProject(id) {
  try {
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.projectRecommend}/${id}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function deleteProject(body) {
  try {
    const response = await apiCMSWithToken.delete(
      `${F18_SERVICES.projectRecommend}/deletes`,
      {
        data: body
      }
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function projectImportExcel(body) {
  const response = await apiCMSWithToken.post(
    // `${F18_SERVICES.post}/import/excel`,
    `/project-recommend/import/excel`,
    body,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  return response
}

export async function notificationList(id) {
  try {
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.projectRecommend}/register?sortBy=created_at&sort=ASC&type=2&project_recommend_id=${id}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}
export async function houseViewList(id) {
  try {
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.projectRecommend}/register?sortBy=created_at&sort=ASC&type=1&project_recommend_id=${id}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function deleteItemNotification(body) {
  try {
    const response = await apiCMSWithToken.delete(
      `${F18_SERVICES.projectRecommend}/acction/deletes`,
      {
        data: body
      }
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function getRegister(p = {}) {
  try {
    const params = new URLSearchParams({ ...p })
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.projectRecommend}/register?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function ProjectRecommendRegisterDelete(id) {
  try {
    const response = await apiCMSWithToken.delete(
      `${F18_SERVICES.projectRecommend}/${id}`
    )

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function ProjectRecommendRegisterUpdate(body, id) {
  const response = await apiCMSWithToken.put(
    `${F18_SERVICES.projectRecommend}/${id}/update-status`,
    body
  )
  return response
}



export async function exportExcel(p = {}) {
  try {
    const params = new URLSearchParams({ ...p })
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.projectRecommend}/register/export?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}


export async function listNote(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(
      `${env.api_url}/note?${params}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function noteAdd(body) {
  const response = await apiCMSWithToken.post(
    `${env.api_url}/note/addnote`,
    body
  )
  return response
}

export async function noteUpdate(body, id) {
  const response = await apiCMSWithToken.put(
    `${env.api_url}/note/${id}`,
    body
  )
  return response
}

export async function noteDelete(body, id) {
  const response = await apiCMSWithToken.delete(
    `${env.api_url}/note/${id}`,
    {
      data: body
    }
  )
  return response
}

export default {
  getAll,
  addProject,
  updateProject,
  detailProject,
  deleteProject,
  projectImportExcel,
  notificationList,
  houseViewList,
  deleteItemNotification,
  getRegister,
  exportExcel,
  listNote,
  noteAdd,
  noteDelete,
  ProjectRecommendRegisterUpdate,
  ProjectRecommendRegisterDelete
}
